import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { revertAll } from "../revertAll"

export interface CachedAssetInfo {
  url: string
  thumbnailUrl?: string
  mediaType?: "IMAGE" | "VIDEO"
  width?: number | null
  height?: number | null
  assetId?: string
  /** AI children already generated from this asset — lets a catalog tile show
   *  that the original has variants. */
  variantCount?: number
}

export interface AssetCacheState {
  /** Maps "sourceType:externalRefId" to resolved image URL */
  urls: Record<string, string>
  /** Maps "sourceType:externalRefId" to full asset info */
  assets: Record<string, CachedAssetInfo>
}

const initialState: AssetCacheState = {
  urls: {},
  assets: {},
}

export type AssetFieldsConfig = {
  externalRefIdKey: string
  sourceTypeKey: string
  urlKey?: string
}

export const assetCacheSlice = createSlice({
  name: "assetCacheSlice",
  initialState,
  extraReducers: builder => builder.addCase(revertAll, () => initialState),
  reducers: {
    cacheAssetUrl(
      state,
      { payload }: PayloadAction<{ key: string; url: string }>,
    ) {
      state.urls[payload.key] = payload.url
    },
    cacheAssetInfo(
      state,
      { payload }: PayloadAction<{ key: string; info: CachedAssetInfo }>,
    ) {
      state.urls[payload.key] = payload.info.url
      state.assets[payload.key] = payload.info
    },
  },
})

export const { cacheAssetUrl, cacheAssetInfo } = assetCacheSlice.actions
